import script from "./AppModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AppModal.vue?vue&type=script&setup=true&lang=js"

import "./AppModal.vue?vue&type=style&index=0&id=51e88693&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e88693"]])

export default __exports__